import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.carrier}packing/validate`;

export interface ValidatePackingCommandPayload {
  packingParcelId: string;
  transportPlanId: string;
  trackingNumber?: string;
  externalCarrierLabelFileId?: string;
  startTimeInLocalRecipientTimezone?: string;
  endTimeInLocalRecipientTimezone?: string;
}

async function validatePackingCommand(
  payload: ValidatePackingCommandPayload,
): Promise<BaseBackResponse | BackResponseFailure> {
  try {
    const response = await apiCall<BaseBackResponse>(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: payload,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default validatePackingCommand;
